import { log } from '../../../engine/log-sidecar'
import { settings } from '../../../engine/settings-sidecar'
import { soundsGeneric } from '../../../engine/soundsGeneric-sidecar'
import { _audioSprite2 } from '../../goat/sound/_audioSprite2-sidecar'
import { chessMusic } from './chessMusic-sidecar'

let doPlayLoaded = false
let soundTest = false

const logNamespace = 'sounds'
export function load(audioJson: any, musicPath: string) {
  chessMusic.setMusicPath(musicPath + '/')
  soundsGeneric.load(audioJson, () => {
    log.x(logNamespace, 'loaded')
    if (doPlayLoaded) {
      playLoaded()
    }
    if (soundTest) {
      setInterval(() => {
        playLoaded()
      }, 500)
    }
  })
  chessMusic.playMusicMenu()
}

export function setVolume(vol: number) {
  soundsGeneric.setSoundVolume(vol)
}

export function toggleSounds() {
  let mute = settings.get().muteSound
  settings.update({ muteSound: !mute, muteAmbient: !mute })
  if (!mute) {
    soundsGeneric.stopAllSounds()
  }
}

// -- current below

// TODO: replace all of these

export function playLoaded() {
  // play / Success()
}
export function playbuttonMouseOver() {
  soundsGeneric.play(_audioSprite2.AnalogButton, 0.33)
}

export function playButtonClick() {
  soundsGeneric.playRandom([
    // _audioSprite2.Button_01,
    _audioSprite2.Button_01_Variation_01,
    _audioSprite2.Button_01_Variation_02,
    _audioSprite2.Button_01_Variation_03,
  ])
}

export function playSelected() {
  soundsGeneric.playRandom([_audioSprite2.Button_01], 0.5)
}

export function playSuccess() {
  soundsGeneric.playRandom([_audioSprite2.Analysis_Single_03], 0.5)
}
export function playFailure() {
  soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}

export function playGameDoneSpectator() {
  soundsGeneric.playRandom([_audioSprite2.Analysis_Single_03], 0.5)
}

export function playVictory() {
  // playSuccess()
  soundsGeneric.playRandom([_audioSprite2.chesswin], 1)
}
export function playLoss() {
  // playFailure()
  soundsGeneric.playRandom([_audioSprite2.chessloss], 1)
}
export function playPiecePickup() {
  // playFootstep()

  soundsGeneric.playRandom(
    [
      _audioSprite2.chesspickupalt1,
      _audioSprite2.chesspickupalt2,
      _audioSprite2.chesspickupalt3,
      // _audioSprite2.foot1,
      // _audioSprite2.foot2,
      // _audioSprite2.foot3,
      // _audioSprite2.foot4,
    ],
    0.5,
  )
}
export function playPieceCreate() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.chesspickup1,
      _audioSprite2.chesspickup2,
      _audioSprite2.chesspickup3,
      _audioSprite2.chesspickup4,
      // _audioSprite2.chesspickup5,
      // _audioSprite2.foot1,
      // _audioSprite2.foot2,
      // _audioSprite2.foot3,
      // _audioSprite2.foot4,
    ],
    0.35,
  )
}

export function playPiecePutdown() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.chessputdown1,
      _audioSprite2.chessputdown2,
      _audioSprite2.chessputdown3,
      _audioSprite2.chessputdown4,
      _audioSprite2.chessputdown5,
      // _audioSprite2.foot1,
      // _audioSprite2.foot2,
      // _audioSprite2.foot3,
      // _audioSprite2.foot4,
    ],
    0.35,
  )
}

export function playPieceKill() {
  soundsGeneric.playRandom(
    [
      _audioSprite2.chesskill1,
      _audioSprite2.chesskill2,
      _audioSprite2.chesskill3,
      _audioSprite2.chesskill4,
      _audioSprite2.chesskill5,
    ],
    0.5,
  )
}

// export function playExplosion() {
//   soundsGeneric.playRandom(
//     [
//       _audioSprite2.MediumExplosion1,
//       _audioSprite2.MediumExplosion2,
//       _audioSprite2.MediumExplosion3,
//     ],
//     0.5,
//   )
// }

export function playCantMoveThere() {
  soundsGeneric.playRandom([_audioSprite2.Negative_02], 1)
}
